import React, { PureComponent, Component } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { STOP_ANALYTICS_INITIATED_BY } from 'aria-viewer/tour/constants/index'
import { setStopInitiatedBy } from 'aria-viewer/analytics/analyticActions'
import { setMapZoom } from './mapActions'
import 'public/assets/css/tour/map'
import 'public/assets/css/mobilemenu'
import 'public/assets/css/tour/directionsController'
import { hideDrawer, showLibraryDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { AUDIO_TOUR, playAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import { setStop } from 'aria-viewer/tour/tourActions'
import { showSupplementalMediaView } from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'

import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { LoadingIndicator } from 'aria-viewer/loadingscreen'
import SVG_ICON_DIRECTIONS from '-!raw-loader!public/assets/svg/icons/icon_directions.svg'
import SVG_ICON_SWAP from '-!raw-loader!public/assets/svg/icons/icon_swap.svg'

import Analytics from 'aria-viewer/analytics/utils/analytics'
import 'public/assets/css/tour/marker.scss'
import { Stop, initGoogleMaps } from '../legacy/tour/map/coordinates_v3'
import { Browser, MapController, MapMarker, iTrail } from '../legacy'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import FONT_EOT from 'public/assets/fonts/icons/iconFont.eot'
import FONT_WOFF from 'public/assets/fonts/icons/iconFont.woff'
import FONT_TTF from 'public/assets/fonts/icons/iconFont.ttf'
import FONT_SVG from 'public/assets/fonts/icons/iconFont.svg'
import BLACK_TILE from 'public/assets/img/map/blacktile.gif'
import $ from 'jquery'
import { Helmet } from 'react-helmet'

const anchorStyle = {
    display: 'inline-block',
}

class StopDirectionDefault extends Component {
    componentDidMount() {
        this.refs.myField.setAttribute('stopid', this.props.stop.id)
    }
    render() {
        const { stop } = this.props
        return (
            <div className="stop" ref="myField">
                {stop.title}
            </div>
        )
    }
}
class StopDirection extends Component {
    componentDidMount() {
        this.refs.myField.setAttribute('stopid', this.props.stop.id)
    }
    render() {
        const { stop } = this.props

        return (
            <div className="stop" ref="myField">
                <div className="text">{stop.title}</div>
            </div>
        )
    }
}

const style = theme => ({
    '@font-face': {
        fontFamily: 'YouVisitIconFont',
        src: `url(${FONT_EOT}) format('embedded-opentype'),
		url(${FONT_WOFF}) format('woff'),
		url(${FONT_TTF}) format('truetype'),
		url(${FONT_SVG}) format('svg')`,
    },
    campusMap: {
        '& .marker, & .current-marker': {
            fontFamily: 'YouVisitIconFont',
            fontSize: '26px',
            color: '#45a4fc',
            textShadow: '-2.5px 0 white, 0 2.5px white, 2.5px 0 white, 0 -2.5px white',
            position: 'absolute',
            right: '-19px',
            top: '-31px',
            zIndex: '1',
            cursor: 'pointer',
            transition: 'color .2s',
        },
        '& .marker.show:before': {
            content: 'attr(data-title)',
            backgroundColor: '#45a4fc',
            fontFamily: '"proxima-nova", sans-serif',
            fontSize: '12px',
            color: '#000',
            position: 'absolute',
            display: 'block',
            whiteSpace: 'nowrap',
            textShadow: 'none',
            padding: '3px 5px',
            bottom: '40px',
            left: '50%',
            display: 'block',
            maxWidth: '75px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            borderRadius: '3px',
            border: '1px solid #1f8ef5',
            transform: 'translateX(-50%)',
        },

        '& .marker:after, .current-marker:after': {
            content: '"L"',
            fontFamily: '"YouVisitIconFont"',
            fontSize: '20px',
            position: 'absolute',
            color: '#000',
            textShadow: '-2.5px 0 black, 0 2.5px black, 2.5px 0 black, 0 -2.5px black',
            opacity: '.5',
            transform: 'skew(-50deg, 25deg)',
            top: '9px',
            right: '-12px',
            zIndex: '-1',
        },

        '& .current-marker': {
            color: '#ff8f1f',
            zIndex: '2',
        },
    },
})
/**
 * 
@include font-face("YouVisitIconFont", "../icons/iconFont");

#campusmap {
  .marker, .current-marker {
    font-family: 'YouVisitIconFont';
    font-size: 26px;
    color: #45a4fc;
    text-shadow: -2.5px 0 white, 0 2.5px white, 2.5px 0 white, 0 -2.5px white;
    position: absolute;
    right: -19px;
    top: -31px;
    z-index: 1;
    cursor: pointer;
    transition: color .2s;
  }

  .marker.show:before { 
    content: attr(data-title);
    background-color: #45a4fc;
    font-family: "proxima-nova", sans-serif;
    font-size: 12px;
    color: #000;
    position: absolute;
    display: block;
    white-space: nowrap;
    text-shadow: none;
    padding: 3px 5px;
    bottom: 40px;
    left: 50%;
    display: block;
    max-width: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    border-radius: 3px;
    border: 1px solid #1f8ef5;
    transform: translateX(-50%);
  }

  .marker:after, .current-marker:after {
    content: "L";
    font-family: "YouVisitIconFont";
    font-size: 20px;
    position: absolute;
    color: #000;
    text-shadow: -2.5px 0 black, 0 2.5px black, 2.5px 0 black, 0 -2.5px black;
    opacity: .5;
    transform: skew(-50deg, 25deg);
    top: 9px;
    right: -12px;
    z-index: -1;
  }

  .current-marker{
    color: #ff8f1f;
    z-index: 2;
  }
}
 */

const S = {
    fullWidthHeight: {
        width: '100%',
        height: '100%',
    },
    relativeFullWidthHeight: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    mainMapSection: {
        top: 0,
        right: 0,
        bottom: 0,
    },
    dropDownMenuDiv: {
        fontSize: 16,
        zIndex: '1000',
    },
    selectStopLabelWrapper: {
        background: '#fff',
        width: '85%',
        position: 'absolute',
    },
}

class MapWrapper extends PureComponent {
    constructor(props) {
        super(props)
        this._zoom = 0
        this.state = {
            loading: true,
            menuOpened: false,
            mapDisplayMode: null,
            currentStop: props.currentStop.stopid || 0,
        }
    }

    /*
		Possible map options
			onDoubleClick: func
			onZoomIn: func
			onZoomOut: func
			zoomControl: boolean
			disableDoubleClickZoom: boolean
	 */
    init(props) {
        const {
            setStop,
            showSupplementalMediaView,
            showLibraryDrawer,
            mapData,
            mapDisplayMode,
            options,
            mapStopMarkers,
            mapTrailPoints,
            currentStop,
            stopsList,
            platform,
            loading,
            setStopInitiatedBy,
            setMapZoom,
            mapZoomBounds,
            tour: { tourid },
            onMapReady,
            mapType,
            isInteractiveMap,
            closeMobileMap,
        } = props
        const self = this

        if (loading || typeof google == 'undefined') {
            //Google is undefined if we can't load it for some reason(china?)
            return
        } else {
            initGoogleMaps()
        }
        let hasGoogleMap = !mapData || !mapData.tiles || mapData.tiles.length === 0

        if (this.mapController) {
            if (hasGoogleMap) {
                this.mapController.set('mapTypeControl', false)
                mapType && this.mapController.setMapTypeId(mapType)
            }
        }

        //Swap stops when a user changes stops
        if (this.mapInitialized && this.state.currentStop != currentStop.stopid) {
            this.props.closeMobileMap && this.props.closeMobileMap()
            this.mapController.selectStop(currentStop.stopid, false)
            this.setState({ currentStop: currentStop.stopid })
        }

        //Make sure we aren't trying to reload the same map
        if (
            this.mapInitialized &&
            this.mapInitialized.loc_id == mapData.loc_id &&
            this.mapInitialized.inst_id == mapData.inst_id &&
            this.mapInitialized.tourid == tourid
        ) {
            return
        }
        if (props.visible && mapData && mapData.mapMarkers) {
            const mapMarkers = mapData.mapMarkers.reduce((mapMarkers, prop) => {
                return [...mapMarkers, new MapMarker(prop.custom_lat, prop.custom_lng, prop.real_lat, prop.real_lng)]
            }, [])

            const stops = mapStopMarkers.reduce((stops, prop) => {
                let path = null
                if (prop.shape) {
                    const filteredPaths = prop.shape.some(value => value.map_type === 'custom')
                        ? prop.shape.filter(value => value.map_type === 'custom')
                        : prop.shape
                    const paths = filteredPaths.reduce((paths, value) => {
                        return [...paths, new google.maps.LatLng(value.lat, value.lng)]
                    }, [])
                    path = new google.maps.Polygon({
                        paths: paths,
                    })
                }
                const {
                    id,
                    college,
                    title,
                    customlat,
                    customlng,
                    reallat,
                    reallng,
                    radius,
                    audio,
                    startLat,
                    startLng,
                    fullMapDescription,
                } = prop
                return [
                    ...stops,
                    new Stop({
                        id,
                        college,
                        title,
                        customlat,
                        customlng,
                        reallat,
                        reallng,
                        radius,
                        audio,
                        startLat,
                        startLng,
                        fullMapDescription,

                        hasVideo: prop.hasVideo || false,
                        totalVideos: prop.totalVideos || 0,
                        videoThumb: prop.videoThumb || '',

                        hasPanorama: prop.hasPanorama || false,
                        totalPanos: prop.totalPanos || 0,
                        panoThumb: prop.panoThumb || '',

                        hasPicture: prop.hasPicture || false,
                        totalPhotos: prop.totalPhotos || 0,
                        photoThumb: prop.photoThumb || '',

                        shape: path,
                    }),
                ]
            }, [])

            const trails = mapData.trails.reduce((trails, prop) => {
                const points = prop.points.reduce((points, value) => {
                    return [...points, new google.maps.LatLng(value.lat, value.lng)]
                }, [])

                return [...trails, new iTrail(prop.trailid, prop.name, points)]
            }, [])

            const trailPoints = !platform.mobile
                ? mapTrailPoints.reduce((trails, prop) => {
                      let points = []
                      for (const index in prop) {
                          const { reallat, reallng } = prop[index]
                          points.push(new google.maps.LatLng(reallat, reallng))
                      }
                      return [
                          ...trails,
                          new google.maps.Polyline({
                              path: points,
                              strokeColor: '#FFA500',
                              strokeOpacity: 0.8,
                              strokeWeight: 5,
                          }),
                      ]
                  }, [])
                : []

            const cs =
                stops.find(stop => stop.id === currentStop.stopid) || //see if the current stop has a marker
                stopsList.reduce((cs, s) => cs || stops.find(stop => stop.id === s.stopid), null) //find any stop that has a marker

            const mapZoom = mapData.mapZoom || 10
            const minZoom = mapData.minZoom || 9
            const maxZoom = mapData.maxZoom || 11

            //Handling a race condition for when the default map zoom needs to be changed
            //TODO: Find that race condition
            clearTimeout(this.mapInitTimeout)
            this.mapInitTimeout = setTimeout(() => {
                setMapZoom({
                    level: mapZoom,
                    min: minZoom,
                    max: maxZoom,
                })
            }, 500)

            const map = {
                stops,
                trails,
                trailPoints,
                isFullMap: !platform.mobile,
                inst_id: mapData.inst_id,
                loc_id: mapData.loc_id,
                loc_uniqueid: mapData.loc_uniqueid,
                drawCircle: mapData.drawCircle,
                hasDirections: mapData.hasDirections,
                hoverColor: mapData.hoverColor,
                startingStop: cs ? cs.id : 0,
                mapZoom,
                minZoom,
                maxZoom,
                mapCenter: new google.maps.LatLng(mapData.center_lat, mapData.center_lng),
                maxCoords: new google.maps.LatLng(mapData.max_lat, mapData.max_lng),
                minCoords: new google.maps.LatLng(mapData.min_lat, mapData.min_lng),
                isMobilePhone: platform.mobile,
                isTablet: platform.tablet,
                isIE: Browser.is('ie'),
                gpsCollector: Analytics && Analytics.analyticsData && Analytics.analyticsData.gpsCollector,
                hasGoogleMap: hasGoogleMap,
                mapMarkers: mapMarkers,
                isInteractiveMap: isInteractiveMap,
                ...options,
            }

            if (this.mapController) {
                this.mapController.destroy()
                this.mapController = null
            }
            this.mapController = MapController
            this.mapController.CustomGetTileUrl = function(coord, zoom) {
                const dir = mapData.tiles[0].path
                const imgDir = '/public/images/'
                const version = mapData.tiles[0].version
                const ext = `.jpg?${version}`

                return mapData.tiles.reduce((tileUrl, prop) => {
                    if (
                        zoom == prop.zoom &&
                        coord.x >= prop.minx &&
                        coord.x <= prop.maxx &&
                        coord.y >= prop.miny &&
                        coord.y <= prop.maxy
                    ) {
                        return `${dir}${coord.x}_${coord.y}_${zoom}${ext}`
                    }
                    return tileUrl ? tileUrl : BLACK_TILE
                }, '')
            }

            this.mapController.onMapReady(() => {
                this.setState({ loading: false })
                onMapReady && onMapReady()
            })

            this.mapController.Init(map)

            this.mapInitialized = {
                loc_id: mapData.loc_id,
                inst_id: mapData.inst_id,
                tourid: tourid,
            }

            this.mapController.onStopSelected(stop => {
                clearTimeout(self.stopChangeTimeout)
                if (self.state.currentStop != stop.id) {
                    const stopIndex = this.getStopIndexByStopId(stop.id)
                    self.stopChangeTimeout = setTimeout(() => {
                        setStopInitiatedBy(STOP_ANALYTICS_INITIATED_BY.map)
                        setStop(stopIndex, false)
                    }, 500)
                }
            })

            this.mapController.onSupplementalMediaSelected((media, stopid) => {
                showSupplementalMediaView({ stopid, media })
                showLibraryDrawer()
            })
        }
    }

    componentDidMount() {
        this.init(this.props)
        const zoomLevel = this.props.mapZoomBounds.get('level')
        this.mapController && this.mapController.resize(zoomLevel, parseInt(styleguide.delay.slow))
    }

    componentWillReceiveProps(newProps) {
        this.init(newProps)
        const zoomLevel = newProps.mapZoomBounds.get('level')

        if (this.props.mapDisplayMode !== newProps.mapDisplayMode || this._zoom !== zoomLevel) {
            // track zoom outside of this.state to avoid rerenders
            this._zoom = zoomLevel
            this.mapController && this.mapController.resize(zoomLevel, parseInt(styleguide.delay.slow))
        }
    }

    componentWillMount() {
        window.yvGoogleMapScriptLoaded = _ => this.init(this.props) // ReInitialze when GoogleMaps script is loaded
        $(document).on('rightMenuOpen rightMenuClosed', this.toggleMenuOpen)
    }

    componentWillUnmount() {
        $(document).off('rightMenuOpen rightMenuClosed', this.toggleMenuOpen)
        if (this.mapController) {
            this.mapController.destroy()
            this.mapController = null
        }
    }

    handleCloseButtonClick = () => {
        const { hideDrawer, playAudio } = this.props
        this.mapController && this.mapController.stopAudio()
        hideDrawer()

        //on closing the map drawer, play the audio tour guide
        playAudio(AUDIO_TOUR)
    }

    toggleMenuOpen = () => {
        this.setState({ menuOpened: !this.state.menuOpened })
    }

    getLoadingIndicator() {
        return (
            <div
                style={{
                    position: 'absolute',
                    width: 100,
                    height: 100,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 5000,
                    display: this.state.loading ? 'block' : 'none',
                }}
                aria-disabled="true"
            >
                <LoadingIndicator class="gray" />
            </div>
        )
    }

    getClosedButton() {
        const { hideCloseButton } = this.props

        return this.state.menuOpened || hideCloseButton ? null : (
            <CloseButton
                onClick={this.handleCloseButtonClick}
                puresvg={true}
                style={{
                    margin: '24px',
                    position: 'absolute',
                    top: '2px',
                    right: '2px',
                    cursor: 'pointer',
                    width: '16px',
                    height: '16px',
                }}
                svgStyle={{
                    WebkitFilter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.5))',
                    filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.5))',
                }}
            />
        )
    }

    addTourButton() {
        const { hasMultipleTrails, mapTourLabel } = this.props
        return hasMultipleTrails ? (
            <div className="button-tours">
                <a style={anchorStyle} href="javascript:void(0)" className="button-tours-anchor">
                    {mapTourLabel}
                </a>
                <i className="select-button" />
            </div>
        ) : null
    }

    addStopButton() {
        return this.props.hasMultipleStops ? (
            <div className="button-stops">
                <a style={anchorStyle} href="javascript:void(0)" className="button-stops-anchor">
                    Stops
                </a>
                <i className="select-button" />
            </div>
        ) : null
    }

    addDirectionsButton() {
        const { mapStopMarkers, mapData, hasMultipleStops } = this.props
        return mapData && mapData.hasDirections && hasMultipleStops ? (
            <div className="directions-container mobile">
                <div className="path-error" />
                <div className="toggle-btn">
                    <div className="icon">
                        <div dangerouslySetInnerHTML={{ __html: SVG_ICON_DIRECTIONS }} />
                    </div>
                    <div className="title">DIRECTIONS</div>
                </div>
                <div className="form">
                    <div className="fields">
                        <div className="field-wrap field0">
                            <div className="circle-wrap">
                                <div className="circle opaque" />
                            </div>
                            <div className="text-field" />
                        </div>
                        <div className="field-wrap field1">
                            <div className="circle-wrap">
                                <div className="circle hollow" />
                            </div>
                            <div className="text-field" />
                        </div>
                        <div className="line-wrap">
                            <div className="line" />
                        </div>
                        <div className="swap-btn">
                            <div dangerouslySetInnerHTML={{ __html: SVG_ICON_SWAP }} />
                        </div>
                    </div>
                </div>
                <div className="stops-list-wrap">
                    <div className="stops-list">
                        <StopDirectionDefault
                            stop={{
                                id: 'current_location',
                                title: 'Current Location',
                            }}
                        />
                        {mapStopMarkers.map((stop, index) => {
                            return <StopDirection stop={stop} key={index} />
                        })}
                    </div>
                </div>
            </div>
        ) : null
    }

    getStopIndexByStopId(stopid) {
        return this.props.stopsList.reduce((val, stop, index) => {
            return stop.stopid == stopid ? index : val
        }, null)
    }

    render() {
        const needsGoogleMapsAPI = typeof google == 'undefined'
        const { style, wrapperStyle, platform, classes } = this.props
        return (
            <div className="mapWrapper" style={Object.assign({}, wrapperStyle, S.fullWidthHeight)}>
                {needsGoogleMapsAPI && (
                    <Helmet>
                        <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDCQE_hMfTdHWzCQiznFlC9jxkZVPOwC1A&callback=yvGoogleMapScriptLoaded"></script>
                    </Helmet>
                )}
                {this.getLoadingIndicator()}
                <audio id="audioPlayer" />
                <div id="overlay" />
                <div className="mobile-stops mobile-info scrolling" style={S.selectStopLabelWrapper}>
                    <label>Select a stop to view map info</label>
                </div>
                <div id="container" style={S.relativeFullWidthHeight}>
                    <section
                        id="main-map-section"
                        className="main-map-section expand scrolling"
                        style={S.mainMapSection}
                    >
                        <div className="main-map-container">
                            <div
                                id="campusmap"
                                className={classes.campusMap}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    background: '#ccc',
                                    ...style,
                                }}
                            />
                        </div>
                        <div id="mobile-overlay" />
                        {this.getClosedButton()}
                    </section>
                    {platform.mobile && (
                        <section tabIndex="-1" id="map-status">
                            <div className="button-locateMe">
                                <a style={anchorStyle} href="javascript:void(0)" />
                            </div>
                            <div className="centered">
                                {this.addTourButton()}
                                {this.addStopButton()}
                            </div>
                            {this.addDirectionsButton()}
                        </section>
                    )}
                </div>
                <section id="map-side-bar" className="map-side-bar expand scrolling" />
                <div id="map-dropmenudiv" className="scrolling" style={S.dropDownMenuDiv} />
            </div>
        )
    }
}

export default compose(
    connect(
        mapSelectorsToProps([
            'drawer',
            'stopsList',
            'currentStop',
            'hasMultipleTrails',
            'hasMultipleStops',
            'mapStopMarkers',
            'mapTrailPoints',
            'trailsList',
            'mapTourLabel',
            'mapData',
            'mapDisplayMode',
            'loading',
            'mapZoomBounds',
            'tour',
        ]),
        {
            hideDrawer,
            setStop,
            showSupplementalMediaView,
            showLibraryDrawer,
            setMapZoom,
            setStopInitiatedBy,
            playAudio,
        }
    ),
    injectSheet(style)
)(MapWrapper)
